new MutationObserver(() => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    });
    document.querySelectorAll("[role='option']").forEach(el => {
        const firstTextContent = el.textContent.trim();
        if (firstTextContent) {
            el.setAttribute('aria-label', firstTextContent);
        }
    })

    document.querySelectorAll("select[role='listbox']").forEach(el => {
        el.setAttribute('aria-label', 'Select frequency')
    })
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('img').forEach(el => {
    if (!el.hasAttribute('alt')) {
        el.setAttribute('alt', '')
    }
})

document.querySelectorAll("[role='option']").forEach(el => {
    const firstTextContent = el.textContent.trim();
    if (firstTextContent) {
        el.setAttribute('aria-label', firstTextContent);
    }
})

document.querySelectorAll("select[role='listbox']").forEach(el => {
    el.setAttribute('aria-label', 'Select frequency')
})
